/* eslint-disable no-shadow */

export const state = {
    activePopper: null,
};

export const mutations = {
    set(state, value) {
        state.activePopper = value;
    },
};

export const actions = {
    set({commit}, value) {
        commit('set', value);
    },
};
